import * as types from '../actions/actionTypes'

export const VENDOR_LOGIN_STATES = {
  PROCESSING: 0,
  CANCELLED: 1,
  SUCCEEDED: 2,
}

export const initialState = {
  fetchingCount: 0,
  snackbars: [],
  toast: '',
  vendorLoginState: VENDOR_LOGIN_STATES.PROCESSING,
}

export function isFetchingSelector(ui) {
  return ui.fetchingCount > 0
}

export function isVendorLoggingInSelector(ui) {
  return ui.vendorLoginState === VENDOR_LOGIN_STATES.PROCESSING
}

export default function uiReducer(ui = initialState, action) {
  switch (action.type) {
    case types.FETCHING:
      return {
        ...ui,
        fetchingCount: ui.fetchingCount + 1,
      }
    case types.FETCH_COMPLETE:
      return {
        ...ui,
        fetchingCount: Math.max(0, ui.fetchingCount - 1),
      }
    case types.APPEND_SNACKBAR:
      return {
        ...ui,
        snackbars: [...ui.snackbars, action.payload],
      }
    case types.SET_SNACKBAR: {
      const snackbar = action.payload
      const { snackbars } = ui
      const sameColorIndex = snackbars.findIndex(
        s => s.color === snackbar.color,
      )
      if (sameColorIndex < 0) {
        return {
          ...ui,
          snackbars: [...snackbars, snackbar],
          toast: snackbar.content,
        }
      }
      return {
        ...ui,
        snackbars: [
          ...snackbars.slice(0, sameColorIndex),
          snackbar,
          ...snackbars.slice(sameColorIndex + 1),
        ],
        toast: snackbar.content,
      }
    }
    case types.REMOVE_SNACKBAR: {
      const snackbarIndex = action.payload
      const { snackbars } = ui
      if (snackbarIndex < 0 || snackbarIndex >= snackbars.length) {
        return { ...ui, toast: '' }
      }
      return {
        ...ui,
        snackbars: [
          ...snackbars.slice(0, snackbarIndex),
          ...snackbars.slice(snackbarIndex + 1),
        ],
        toast: '',
      }
    }
    case types.LOGIN_ERROR:
      return {
        ...ui,
        vendorLoginState: VENDOR_LOGIN_STATES.CANCELLED,
      }
    case types.SET_VENDOR_LOGIN_STATE:
      return {
        ...ui,
        vendorLoginState: action.payload || VENDOR_LOGIN_STATES.CANCELLED,
      }
    default:
      return ui
  }
}
